export enum BmReportsAutoCounterMessages {
  RESET_LABEL = 'Reset / update counter',
}
